import { useEffect } from 'react';

export function useDocumentTitle(title: string) {
  useEffect(() => {
    const baseTitle = 'Dissai - студия контента';
    document.title = title ? `${title} | ${baseTitle}` : baseTitle;
  }, [title]);
} 